@if (media?.length) {
<swiper [navigation]="{
            nextEl: '.pdp-detailsFeatures-next',
            prevEl: '.pdp-detailsFeatures-prev'
        }"
        [slidesPerView]="'auto'"
        [style.--pc-slides-ceil]="pcSlidesCeil"
        [style.--pc-slides]="pcSlides"
        [style.--pc-gutter]="pcGutter"
        [freeMode]="true">
    @for (item of media; track $index) {
    <ng-template swiperSlide>
        <div class="ratio-1-1">
            <img class="fill"
                 [image]="item.image">
            @if (item.alt_text) {
            <div class="fill _textOverlay p-a-3">
                <p [sizeClass]="'SM:h4, !SM:h3'">{{item.alt_text}}</p>
            </div>
            }
        </div>
    </ng-template>
    }
</swiper>
<!-- navigation -->
<slider-arrows [swiperPrefix]="'pdp-detailsFeatures'"></slider-arrows>
}